<template>
  <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          icon
          v-bind="attrs"
          v-on="on"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-row justify="center">
      <v-col cols="6">
      <v-card>
        <v-toolbar
            dark
            color="primary"
        >
          <v-btn
              icon
              dark
              @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Add new position</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                dark
                text
                @click="save"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                      v-model="title"
                      label="Company Name"
                      required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                      v-model="symbol"
                      label="Company Symbol"
                      required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-textarea
                      solo
                      name="input-7-4"
                      label="Summary"
                      v-model="summary"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                            name="input-7-4"
                      label="Position Cost"
                      v-model="positionCost"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
export default {
  name: "AddDetailsComponent",
  data() {
    return {
      dialog: false,
      title: '',
      symbol: '',
      summary: '',
      positionCost : 0
    }
  },
  methods: {
    save() {
      this.dialog = false;
      this.$store.commit('createNewPosition', {
        title: this.title,
        summary : this.summary,
        symbol: this.symbol,
        positionCost: parseFloat(this.positionCost)
      });
    }
  }
}
</script>

<style scoped>

</style>